// removed by extract-text-webpack-plugin
module.exports = {"header":"_2lvlnnwbHAKXleEfXvVPi0","unsubscription_container":"_2X24UPUSVo0BUN6wvQcJEi","email_phone_textbox":"_3huSmM_mbRdoNl8PxVTAzQ","email_phone_text":"_25eamhkozbLjSkL-MRZtDp","email_phone_box":"_39cvjIE6j-8RByXJfu1ryy","label":"_37-_fJ5qHo49OKC10pevct","submit":"HPHdF4pdurW45FpKo0v3W","subscribe":"_3INIwwNFgHDqfMxd0pvPC4","unsubscribe":"_2F_6xR8IWFNVjfzyABxNYm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Unsubscription/Unsubscription.scss
// module id = 2418
// module chunks = 0